import { useState } from "react";
import { Alert, Box, Button } from "@mui/material";
import { Download } from "lucide-react";
import sparePartsApi from "../../../api/spareParts.api";

export default function DataExportButton({ kind, filters = {}, disabled = false, label = "Export", fileName }: {
  kind: string; filters?: object; disabled?: boolean; label?: string; fileName?: string;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const extension = ["requests", "transfers", "receipts", "issues", "returns", "spareUsage", "invoices"].includes(kind) ? "pdf" : "xlsx";
  const download = async () => {
    setBusy(true); setError("");
    try {
      const response = await sparePartsApi.get(`/exports/${kind}`, { params: filters, responseType: "blob", timeout: 120_000 });
      const url = URL.createObjectURL(response.data);
      const baseName = fileName?.replace(/\.(xlsx|pdf)$/i, "").replace(/[^a-zA-Z0-9_.-]/g, "_") || `${kind}-export`;
      const link = document.createElement("a"); link.href = url; link.download = `${baseName}.${extension}`; link.click();
      window.setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (requestError: any) {
      let message = "Unable to export. Check your access and try again.";
      try {
        const data = requestError?.response?.data;
        const response = data instanceof Blob ? JSON.parse(await data.text()) : data;
        message = response?.message || message;
      } catch { /* Keep a readable message for non-JSON gateway errors. */ }
      setError(message);
    } finally { setBusy(false); }
  };
  return <Box sx={{ minWidth: 0, maxWidth: "100%" }}>
    <Button variant="outlined" startIcon={<Download size={18} />} disabled={disabled || busy} onClick={download}>{busy ? "Exporting..." : label}</Button>
    {error && <Alert severity="error" onClose={() => setError("")} sx={{ mt: 1, maxWidth: 360, overflowWrap: "anywhere" }}>{error}</Alert>}
  </Box>;
}
